export class ItemId {

  id: number;

  constructor(id: number) {
    this.id = id;
  }

}
